import { render } from "./PaymentsPage.vue?vue&type=template&id=1a3c05a4&scoped=true&ts=true"
import script from "./PaymentsPage.vue?vue&type=script&lang=ts"
export * from "./PaymentsPage.vue?vue&type=script&lang=ts"

import "./PaymentsPage.vue?vue&type=style&index=0&id=1a3c05a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a3c05a4"]])

export default __exports__